module.exports = __webpack_public_path__ + "img/Login-logo.5e737226.png";